import locale from '@glu/locale';

// According current design on uxpin (apr-2018) some strings look like this "Show All Columns",
// but we had a few GLU tickets in Jira, where it's fixed to like this "Show all columns"
// Don't know what should be as rule, so leave this comment here,
// and use Sentence case in strings values, as it was before.

locale.set({
  addAnotherFilter: 'Add another filter',
  // addColumns: 'Add columns', // looks like not used
  // addFilter: 'Add filter', // looks like not used
  // advancedSearch: 'Advanced search', // looks like not used
  // 'advancedSearch.apply.changes': 'Apply changes', // looks like not used. Used 'apply' instead
  allColumns: 'All columns',
  clearFilter: 'Clear filter',
  clearFilters: 'Clear filters',
  columnHeader: 'Column header',
  entireTable: 'Entire table',
  'filter.equal': 'is equal to',
  'filter.less': 'is less than',
  'filter.less.or.equal': 'is less than or equal to',
  'filter.greater': 'is greater than',
  'filter.greater.or.equal': 'is greater than or equal to',
  'filter.between': 'is between',
  firstPage: 'First page',
  jumpToLastPage: 'Jump to last page',
  lastPage: 'Last page',
  loadMore: 'Load More', // mobile grid. GLU-852
  makeDefault: 'Make default',
  makeDefaultSavedView: 'Make default saved view',
  makeDefaultSavedViewMsg: 'Are you sure you want to make default saved view "{0}"?',
  manage: 'Manage', // used in multiColumnSortView.js
  manageColumns: 'Manage columns', // not used, because UI changed
  manageFilters: 'Manage filters',
  multiSortTitle: 'Intelligent Sort',
  notCurrentlyDisplayed: 'Not currently displayed',
  nextPage: 'Next Page',
  notProvideFilteringMsg: 'Grid does not support filtering and no collection was provided.',
  of: 'of',
  page: 'Page',
  pagination: 'Pagination',
  perPage: 'per page',
  previousPage: 'Previous page',
  records: 'records',
  recordsPerPage: 'records per page',
  // remove: 'Remove', // looks like not used
  // removeColumn: 'Remove column', // looks like not used anymore
  // removeColumnMsg: 'Removing this column will also remove the associated Filter Criteria.', // looks like not used anymore
  // removeConfirmTitle: 'Confirm Remove', // looks like not used anymore
  removeSavedView: 'Remove saved view',
  removeSavedViewMsg: 'Are you sure you want to delete saved view "{0}"?',
  // searchField: 'Search field', // looks like not used anymore
  searchValue: 'Search value',
  selectAllRows: 'Select all rows',
  selectFields: 'Select fields',
  selectRow: 'Select Row', // mobile grid. GLU-852
  selectView: 'Select view',
  savedViewName: 'Saved view name',
  savedViews: 'Saved views',
  'savedViews.viewChanged': '{0} - Changed',
  saveThisView: 'Save this view',
  showAllColumns: 'Show all columns',
  thereIsNoContent: 'No {0} found',
  thereIsNoTableCaption: 'There is no table caption',
  through: 'through',
  youAreViewing: 'You are viewing page number',
  viewing: 'Viewing'
});
